<h1 class="text-center">Upozornění</h1>
<p *ngIf="config?.data?.msg" class="text-center info pb-20 pt-20 pr-15">{{config.data.msg}}</p>
<div class="text-center">
    <gmt-button [clickAction]="onClose">Rozumím</gmt-button>
</div>
